import moment from "moment";
import Vue from "vue";
import axios from "axios";
import {
    URL_BASE
} from "../helper/constant";
import NodeLockPannelService from "../services/NodeLockPannelService";
import CommonService from "../services/CommonService";
import PaymentRequestService from "../services/PaymentRequestService";

export const getOptions = (url, method, token, payload) => {
    let options = {
        method: method || "GET",
        url: url,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        }
    };
    if (token) {
        options.headers["Authorization"] = `Bearer ${token}`;
    }
    if (method == "GET" && payload) {
        options["params"] = payload;
    }
    if (payload) {
        options["method"] = method || "POST";
        options["data"] = payload;
    }
    return options;
};

export const globalPermissionStatus = key => {
    if (
        localStorage.getItem("departmentName") != "" &&
        localStorage.getItem("designation") != "" &&
        localStorage.getItem("loginId") &&
        localStorage.getItem("departmentName") != undefined &&
        localStorage.getItem("designation") != undefined &&
        localStorage.getItem("loginId") != undefined
    ) {
        let array = localStorage.getItem("departmentName").split(",");

        let newVal = array.indexOf(key);

        if (newVal >= 0) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;

    }

    // console.log("herer >>>", typeof returnArray, returnArray.length, returnArray[0].split("-")[1])
    return returnArray.length > 0 ? returnArray[0].split("-")[1] : null;

};
export const lastVisitPage = key => {

    if (localStorage.getItem("oldRoute") != key) {
        localStorage.removeItem("lastVisitPage")
    }


};
//used in fetching image files from image uploader.
export const getMaterialImages = e => {
    return Object.keys(e)
        .map(x => {
            if (x != "length") {
                return e[x];
            } else {
                return null;
            }
        })
        .filter(x => x != null && x != undefined);
};

//used in styling of material date picker

export const options = {
    type: "day",
    week: ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
    month: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    format: "YYYY-MM-DD",
    placeholder: "",
    inputStyle: {
        display: "inline-block",
        padding: "6px",
        "line-height": "22px",
        "font-size": "16px",
        border: "5px solid #ffffff",
        "box-shadow": "0 1px 5px 0 rgba(0, 0, 0, 0.2)",
        "border-radius": "3px",
        color: "#5F5F5F"
    },
    color: {
        header: "#3F51B5",
        headerText: "#fff"
    },
    buttons: {
        ok: "OK",
        cancel: "CANCEL"
    },
    overlayOpacity: 0.0001, // 0.5 as default
    dismissible: true // as true as default
};

export const getCurrentDate = () => {
    let d = new Date();
    let date = d.getDate();
    let month = (d.getMonth() + 1).toString();
    if (month.length < 2) {
        month = "0" + month;
    }
    let year = d.getFullYear();
    let _string = "";
    _string = year + "-" + month + "-" + date;
    //console.log("##########", _string);
    return _string;
};

export const formatDate = Vue.filter("formatDate", function (value) {
    if (value) {
        return moment(String(value)).format("MM/DD/YYYY hh:mm");
    }
});

export const fixData = {};

export const GlobalGetLocation = function (options2, callback) {
    let options = {
        method: "POST",
        url: `${URL_BASE}/getPaginatedLocationList.php`,
        data: JSON.stringify(options2),
        crossDomain: true,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
            // Authorization: this.$sessionsStorage.get("loginId")
        }
    };

    axios(options)
        .then(result => {
            const {
                statusText,
                status,
                data
            } = result;
            if (status == 200 && data) {
                callback(null, data.locationDetail);
            }
        })
        .catch(error => {
            callback(error, null);
        });
};

// Fetch currency list (Node/PHP compatible) with a simple callback signature
export const GlobalGetCurrencies = function (options2, callback) {
    try {
        const payload = JSON.stringify(options2 || {});
        CommonService.getAllCurrencyList(payload)
            .then((resp) => {
                const { status, data } = resp;
                if (status !== 200 || !data) {
                    callback(null, []);
                    return;
                }
                const list = Array.isArray(data.CurrencyList)
                    ? data.CurrencyList
                    : Array.isArray(data.currencyList)
                    ? data.currencyList
                    : Array.isArray(data)
                    ? data
                    : [];
                callback(null, list);
            })
            .catch((error) => {
                callback(error, []);
            });
    } catch (e) {
        callback(e, []);
    }
};

// Fetch purchase expense list (Node) with a simple callback signature
export const GlobalGetPurchaseExpense = function (options2, callback) {
    try {
        const payload = options2 || {};
        PaymentRequestService.getPurchaseExpense(payload)
            .then((resp) => {
                const { status, data } = resp;
                if (status === 200 && data && data.status) {
                    const list = Array.isArray(data.data) ? data.data : [];
                    const jobDetails = data.JobDetails || null;
                    callback(null, { list, jobDetails, raw: data });
                } else {
                    callback(null, { list: [], jobDetails: null, raw: data });
                }
            })
            .catch((error) => {
                callback(error, { list: [], jobDetails: null, raw: null });
            });
    } catch (e) {
        callback(e, { list: [], jobDetails: null, raw: null });
    }
};

// Fetch Nature Of Expense master list (Node) with a simple callback signature
export const GlobalGetNatureOfExpense = function (options2, callback) {
    try {
        const payload = options2 || {};
        NodeLockPannelService.getNatureOfExpense(payload)
            .then((resp) => {
                const { status, data } = resp;
                if (status === 200 && data && Array.isArray(data.data)) {
                    callback(null, data.data);
                } else {
                    callback(null, []);
                }
            })
            .catch((error) => {
                callback(error, []);
            });
    } catch (e) {
        callback(e, []);
    }
};

// Utility: find a Nature Of Expense by its label and return the matched item (or null)
export const findNatureOfExpenseByLabel = function (list, label) {
    try {
        const arr = Array.isArray(list) ? list : [];
        const item = arr.find((x) => x && x.label === label);
        return item ? item : null;
    } catch (e) {
        return null;
    }
};
export const GlobalGetCommodity = function (options2, callback) {
    let options = {
        method: "POST",
        url: `${URL_BASE}/globalApi/getGlobalCommodity.php`,
        data: JSON.stringify(options2),
        crossDomain: true,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        }
    };

    axios(options)
        .then(result => {
            const {
                statusText,
                status,
                data
            } = result;
            if (status == 200 && data) {
                callback(null, data.commodityListData);
            }
        })
        .catch(error => {
            callback(error, null);
        });
};
export const GlobalGetCommodity2 = function (options2, callback) {
    let options = {
        method: "POST",
        url: `${URL_BASE}/globalApi/getGlobalCommodity2.php`,
        data: JSON.stringify(options2),
        crossDomain: true,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        }
    };

    axios(options)
        .then(result => {
            const {
                statusText,
                status,
                data
            } = result;
            if (status == 200 && data) {
                callback(null, data.commodityListData);
            }
        })
        .catch(error => {
            callback(error, null);
        });
};

export const GlobalContainerValid = function containerCalculation(containerNo) {
    let trimCon = containerNo.substring(0, 10);
    let input = trimCon;

    //  alert(input)
    let inputArr = [{
        key: "A",
        value: 10
    },
    {
        key: "B",
        value: 12
    },
    {
        key: "C",
        value: 13
    },
    {
        key: "D",
        value: 14
    },
    {
        key: "E",
        value: 15
    },
    {
        key: "F",
        value: 16
    },
    {
        key: "G",
        value: 17
    },
    {
        key: "H",
        value: 18
    },
    {
        key: "I",
        value: 19
    },
    {
        key: "J",
        value: 20
    },
    {
        key: "K",
        value: 21
    },
    {
        key: "L",
        value: 23
    },
    {
        key: "M",
        value: 24
    },
    {
        key: "N",
        value: 25
    },
    {
        key: "O",
        value: 26
    },
    {
        key: "P",
        value: 27
    },
    {
        key: "Q",
        value: 28
    },
    {
        key: "R",
        value: 29
    },
    {
        key: "S",
        value: 30
    },
    {
        key: "T",
        value: 31
    },
    {
        key: "U",
        value: 32
    },
    {
        key: "V",
        value: 34
    },
    {
        key: "W",
        value: 35
    },
    {
        key: "X",
        value: 36
    },
    {
        key: "Y",
        value: 37
    },
    {
        key: "Z",
        value: 38
    }
    ];

    // let input = "GVTU300038";//containerNo
    let rowInput = [...input];
    let multiplier = 2;
    let sum = 0;
    let arrMulti = [1];
    let arrayFinal = [];

    rowInput.map((item, index) => {
        let value = multiplier * arrMulti[index];
        arrMulti.push(value);
        let arrayFilter = inputArr.filter(x => {
            return x.key == item;
        });
        let totalMultiply = 1;
        if (arrayFilter.length > 0) {
            totalMultiply = arrMulti[index] * arrayFilter[0].value;
        } else {
            totalMultiply = arrMulti[index] * parseInt(item);
        }
        sum = sum + totalMultiply;
        arrayFinal.push(totalMultiply);
    });
    let rounValue = parseInt((sum / 11).toString().split(".")[0] * 11);
    let finalValLastDigit = sum - rounValue;
    if (finalValLastDigit == 10) {
        finalValLastDigit = 0;
    }
    let finalContainerNo = input + finalValLastDigit;

    //console.log(, "ii");
    console.log(
        "stringSum :",
        arrMulti,
        arrayFinal,
        sum,
        sum - rounValue,
        "==",
        finalContainerNo
    );
    return finalContainerNo;
};

export const getParseDateYMDFormate = (dateString) => {
    if(!dateString) return null;
    // Split the date string into day, month, and year components
    const [year, month, day] = dateString.split("-").map(Number);

    // Create a new Date object with the parsed components
    return new Date(year, month - 1, day); // Month is zero-indexed in JavaScript Date
};
export const getParseDateYMDFormateTime = (dateString) => {
  if (!dateString) return null;

  const date = new Date(dateString);
  if (isNaN(date)) return null;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return {date: new Date(year, month - 1, day),time:`${hours}:${minutes}:${seconds}`};
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const getParseDateDMYFormate = (dateString) => {
    // Split the date string into day, month, and year components
    const [day, month, year] = dateString.split("-").map(Number);

    // Create a new Date object with the parsed components
    return new Date(year, month - 1, day); // Month is zero-indexed in JavaScript Date
};

export const getConsoleBooking = function (options2, callback) {
    // Prepare request options
    let options = {
        method: "POST",
        url: `${URL_BASE}/Api_ConsoleBooking/viewAllconsoleBookingList.php`,
        data: JSON.stringify(options2),
        crossDomain: true,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: options2.loginId, // Pass the loginId in options2
        },
    };

    // Make the axios call
    axios(options)
        .then((result) => {
            const { status, data } = result;
            if (status === 200 && data) {
                // If data is valid, pass it to the callback
                if (data.ConsoleBookingList.length > 0) {
                    callback(null, data.ConsoleBookingList);
                } else {
                    callback(null, { message: data.txt_msg, list: [] });
                }
            }
        })
        .catch((error) => {
            // Pass error to the callback
            callback(error, null);
        });
};

export const getConsoleBookingNew = function (options2, callback) {

    NodeLockPannelService.getAllConsoleBookingList(options2)
    .then((response) => {
        const { status, data } = response;
        console.log('data NodeLockPannelService getAllConsoleBookingList=>', data);
        if (status === 200 && data) {
            // If data is valid, pass it to the callback
            if (data) {
                callback(null, data);
            } else {
                callback(null, { message: data.txt_msg, list: [] });
            }
        }
    })
    .catch((error) => {
        callback(error, null);
        console.log("Catch on getAllConsoleBookingList Error: ", error);
    });
};

export const getJobNatureOfExpenseList = function (options2, callback) {
    // Prepare request options
    let payload = { 
        module_id: options2.module_id, 
        jobNo: options2.jobNo, 
        moduleType: options2.moduleType, 
        transportType: options2.transportType, 
        branchId: options2.branchId 
    };

    NodeLockPannelService.getJobNatureOfExpense(payload)
        .then((response) => {
            const { data, status, statusText } = response;
            console.log("NatureOfExpense", data);
            if (status == 200 && data) {
                if (data.data && data.data.length > 0) {
                    // Return success with data and validation flag
                    callback(null, {
                        natureOfExpense: data.data,
                        is_noe_validation: data.is_noe_validation == 1
                    });
                } else {
                    // Return empty data
                    callback(null, {
                        natureOfExpense: [],
                        is_noe_validation: false
                    });
                }
            } else {
                // Return error for invalid status
                callback(new Error(`Invalid status: ${status}`), null);
            }
        })
        .catch((error) => {
            console.log("Catch on getJobNatureOfExpense Error: ", error);
            callback(error, null);
        });
};



// WEBPACK FOOTER //
// ./src/helper/collection.js